// Wishlist functionality 

class Wishlist { 

  constructor() { 

    this.storageKey = "shopify_wishlist" 

    this.items = this.getWishlist() 

    this.selectors = { 

      wishlistButton: "[data-wishlist-button]", 

      wishlistCounter: "[data-wishlist-counter]", 

      wishlistPage: ".wishlist-container", 

      wishlistItems: "#wishlist-items", 

      wishlistEmpty: "#wishlist-empty", 

      addToCartButtons: ".wishlist-add-to-cart", 

      removeButtons: ".wishlist-remove", 

      notification: "#wishlist-notification", 

      notificationImage: "#wishlist-notification-image", 

      notificationMessage: "#wishlist-notification-message", 

    } 

 

    this.classes = { 

      active: "is-active", 

      loading: "is-loading", 

      hidden: "is-hidden", 

      added: "is-added", 

    } 

 

    this.init() 

    this.initOnPageLoad() 

    this.createNotificationElement() 

  } 

 

   

 

  // Create notification element if it doesn't exist 

  createNotificationElement() { 

    if (!document.querySelector(this.selectors.notification)) { 

      const notificationHTML = ` 

        <div id="wishlist-notification" class="wishlist-notification"> 

          <div class="wishlist-notification-content"> 

            <img id="wishlist-notification-image" src="/placeholder.svg" alt=""> 

            <p id="wishlist-notification-message"></p> 

          </div> 

        </div> 

      ` 

      document.body.insertAdjacentHTML("beforeend", notificationHTML) 

    } 

  } 

// Add this method after createNotificationElement() 

observeCounterChanges() { 

  const counters = document.querySelectorAll(this.selectors.wishlistCounter); 

   

  counters.forEach(counter => { 

    // Create an observer to watch for class changes 

    const observer = new MutationObserver((mutations) => { 

      mutations.forEach((mutation) => { 

        if (mutation.attributeName === 'class') { 

          const count = this.items.length; 

          // If counter has items but is hidden, fix it 

          if (count > 0 && counter.classList.contains(this.classes.hidden)) { 

            console.log("Counter was hidden incorrectly, fixing..."); 

            counter.classList.remove(this.classes.hidden); 

            counter.textContent = count; 

          } 

        } 

      }); 

    }); 

     

    // Start observing 

    observer.observe(counter, { 

      attributes: true, 

      attributeFilter: ['class'] 

    }); 

  }); 

} 

  // Add this method to the Wishlist class 

  initOnPageLoad() { 

    // Check if we're on a collection page or product page 

    const isProductPage = window.location.pathname.includes("/products/") 

    const isCollectionPage = window.location.pathname.includes("/collections/") 

    const isWishlistPage = window.location.pathname.includes("/pages/wishlist") 

 

    // Initialize wishlist buttons with a slight delay to ensure DOM is fully loaded 

    setTimeout(() => { 

      this.updateWishlistButtons() 

 

      // If we're on the wishlist page, update the wishlist items 

      if (isWishlistPage) { 

        this.updateWishlistPage() 

      } 

 

      // Update the counter in the header 

      this.updateWishlistCounter() 

      this.observeCounterChanges() // Add this line 

    }, 100) 

  } 

 

  init() { 

    this.initWishlistButtons() 

    this.initWishlistPage() 

    this.updateWishlistCounter() 

    this.updateWishlistButtons() 

 

    // Listen for storage events to sync across tabs 

    window.addEventListener("storage", (event) => { 

      if (event.key === this.storageKey) { 

        this.items = JSON.parse(event.newValue || "[]") 

        this.updateWishlistButtons() 

        this.updateWishlistCounter() 

        this.updateWishlistPage() 

      } 

    }) 

  } 

 

  getWishlist() { 

    const wishlist = localStorage.getItem(this.storageKey) 

    return wishlist ? JSON.parse(wishlist) : [] 

  } 

 

  saveWishlist() { 

    localStorage.setItem(this.storageKey, JSON.stringify(this.items)) 

    this.updateWishlistCounter() 

    this.updateWishlistButtons() 

 

    // Dispatch a custom event that can be listened to by other scripts 

    const event = new CustomEvent("wishlist:updated", { 

      detail: { 

        items: this.items, 

      }, 

    }) 

    document.dispatchEvent(event) 

  } 

updateWishlistCounter() { 

  const counters = document.querySelectorAll(this.selectors.wishlistCounter) 

  if (counters.length === 0) return 

 

  const count = this.items.length 

   

  counters.forEach(counter => { 

    counter.textContent = count 

 

    if (count > 0) { 

      counter.classList.remove(this.classes.hidden) 

    } else { 

      counter.classList.add(this.classes.hidden) 

    } 

  }) 

} 

 

  initWishlistButtons() { 

    const buttons = document.querySelectorAll(this.selectors.wishlistButton) 

 

    buttons.forEach((button) => { 

      const productId = button.dataset.productId 

 

      // Set initial state 

      if (this.isInWishlist(productId)) { 

        button.classList.add(this.classes.added) 

      } 

 

      button.addEventListener("click", (event) => { 

        event.preventDefault() 

        event.stopPropagation() 

        this.toggleWishlistItem(button) 

      }) 

    }) 

  } 

 

  updateWishlistButtons() { 

    const buttons = document.querySelectorAll(this.selectors.wishlistButton) 

 

    buttons.forEach((button) => { 

      const productId = button.dataset.productId 

 

      if (this.isInWishlist(productId)) { 

        button.classList.add(this.classes.added) 

        // Update the heart icon to be filled 

        const heartIcon = button.querySelector(".icon-heart") 

        if (heartIcon) { 

          heartIcon.setAttribute("fill", "currentColor") 

        } 

      } else { 

        button.classList.remove(this.classes.added) 

        // Update the heart icon to be outlined 

        const heartIcon = button.querySelector(".icon-heart") 

        if (heartIcon) { 

          heartIcon.setAttribute("fill", "none") 

        } 

      } 

    }) 

  } 

 

  toggleWishlistItem(button) { 

    const productId = button.dataset.productId 

    const productTitle = button.dataset.productTitle 

    const productImage = button.dataset.productImage 

    const productUrl = button.dataset.productUrl 

    const productPrice = button.dataset.productPrice 

    const variantId = button.dataset.variantId 

 

    const heartIcon = button.querySelector(".icon-heart") 

 

    if (this.isInWishlist(productId)) { 

      this.removeFromWishlist(productId) 

      button.classList.remove(this.classes.added) 

      if (heartIcon) { 

        heartIcon.setAttribute("fill", "none") 

      } 

      this.showNotification(productImage, `${productTitle} removido da lista de desejos`) 

    } else { 

      this.addToWishlist({ 

        id: productId, 

        title: productTitle, 

        image: productImage, 

        url: productUrl, 

        price: productPrice, 

        variant_id: variantId, 

      }) 

      button.classList.add(this.classes.added) 

      if (heartIcon) { 

        heartIcon.setAttribute("fill", "currentColor") 

      } 

      this.showNotification(productImage, `${productTitle} adicionado à lista de desejos`) 

    } 

  } 

 

  isInWishlist(productId) { 

    return this.items.some((item) => item.id === productId) 

  } 

 

  addToWishlist(product) { 

    if (!this.isInWishlist(product.id)) { 

      this.items.push(product) 

      this.saveWishlist() 

    } 

  } 

 

  removeFromWishlist(productId) { 

    this.items = this.items.filter((item) => item.id !== productId) 

    this.saveWishlist() 

    this.updateWishlistPage() 

  } 

 

  initWishlistPage() { 

    const wishlistPage = document.querySelector(this.selectors.wishlistPage) 

    if (!wishlistPage) return 

 

    this.updateWishlistPage() 

 

    // Event delegation for wishlist page actions 

    wishlistPage.addEventListener("click", (event) => { 

      const target = event.target 

 

      // Handle remove button clicks 

      if (target.closest(this.selectors.removeButtons)) { 

        const button = target.closest(this.selectors.removeButtons) 

        const productId = button.dataset.productId 

        const item = button.closest(".wishlist-item") 

 

        // Add animation class before removing 

        item.classList.add("removing") 

 

        // Wait for animation to complete before removing from DOM 

        setTimeout(() => { 

          this.removeFromWishlist(productId) 

        }, 300) 

      } 

 

      // Handle add to cart button clicks 

      if (target.closest(this.selectors.addToCartButtons)) { 

        const button = target.closest(this.selectors.addToCartButtons) 

        const variantId = button.dataset.variantId 

        const productId = button.dataset.productId 

 

        this.addToCart(variantId, productId, button) 

      } 

    }) 

  } 

 

  updateWishlistPage() { 

    const wishlistItems = document.querySelector(this.selectors.wishlistItems) 

    const wishlistEmpty = document.querySelector(this.selectors.wishlistEmpty) 

 

    if (!wishlistItems || !wishlistEmpty) return 

 

    if (this.items.length === 0) { 

      wishlistItems.innerHTML = "" 

      wishlistEmpty.classList.remove(this.classes.hidden) 

      return 

    } 

 

    wishlistEmpty.classList.add(this.classes.hidden) 

 

    // Get the template 

    const template = document.getElementById("wishlist-item-template").innerHTML 

 

    // Render items 

    wishlistItems.innerHTML = this.items 

      .map((item) => { 

        return template 

          .replace(/\[\[id\]\]/g, item.id) 

          .replace(/\[\[title\]\]/g, item.title) 

          .replace(/\[\[image\]\]/g, item.image) 

          .replace(/\[\[url\]\]/g, item.url) 

          .replace(/\[\[price\]\]/g, item.price) 

          .replace(/\[\[variant_id\]\]/g, item.variant_id) 

      }) 

      .join("") 

  } 

 

  async addToCart(variantId, productId, button) { 

    if (!variantId) return 

 

    button.classList.add(this.classes.loading) 

 

    try { 

      const response = await fetch("/cart/add.js", { 

        method: "POST", 

        headers: { 

          "Content-Type": "application/json", 

        }, 

        body: JSON.stringify({ 

          id: variantId, 

          quantity: 1, 

        }), 

      }) 

 

      if (!response.ok) { 

        throw new Error("Falha ao adicionar ao carrinho") 

      } 

 

      const data = await response.json() 

 

      // Find the product in wishlist 

      const product = this.items.find((item) => item.id === productId) 

 

      // Show notification 

      if (product) { 

        this.showNotification(product.image, `${product.title} adicionado ao carrinho`) 

 

        // Remove the product from wishlist after adding to cart 

        this.removeFromWishlist(productId) 

      } 

 

      // Update cart drawer 

      if (typeof window.updateCartDrawer === "function") { 

        window.updateCartDrawer() 

      } else { 

        // Fallback to refreshing the page 

        window.location.href = "/cart" 

      } 

    } catch (error) { 

      console.error("Error adding to cart:", error) 

      alert("Não foi possível adicionar ao carrinho. Tente novamente.") 

    } finally { 

      button.classList.remove(this.classes.loading) 

    } 

  } 

 

  showNotification(image, message) { 

    const notification = document.querySelector(this.selectors.notification) 

    const notificationImage = document.querySelector(this.selectors.notificationImage) 

    const notificationMessage = document.querySelector(this.selectors.notificationMessage) 

 

    if (!notification || !notificationImage || !notificationMessage) return 

 

    notificationImage.src = image 

    notificationMessage.textContent = message 

 

    notification.classList.add(this.classes.active) 

 

    // Hide notification after 3 seconds 

    clearTimeout(this.notificationTimeout) 

    this.notificationTimeout = setTimeout(() => { 

      notification.classList.remove(this.classes.active) 

    }, 3000) 

  } 

} 

 

// Initialize wishlist when DOM is ready 

document.addEventListener("DOMContentLoaded", () => { 

  window.wishlist = new Wishlist() 

}) 

 

 